
const STORAGE_KEY = "tyk:marketingAttribution";
const PARAM_KEYS = ["fbclid", "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

const isBrowser = () => typeof window !== "undefined";

const getSessionStorage = () => {
  if (!isBrowser()) {
    return null;
  }
  try {
    return window.sessionStorage;
  } catch (error) {
    return null;
  }
};

const sanitizeParams = (params) =>
  Object.fromEntries(
    Object.entries(params || {}).filter(([, value]) => typeof value === "string" && value.trim() !== "")
  );

export const extractCampaignParams = (search = "") => {
  if (typeof search !== "string" || search.trim() === "") {
    return {};
  }

  const query = search.startsWith("?") ? search : `?${search}`;
  const parsed = new URLSearchParams(query);
  const result = {};

  PARAM_KEYS.forEach((key) => {
    const value = parsed.get(key);
    if (value) {
      result[key] = value;
    }
  });

  return result;
};

export const getStoredCampaignParams = () => {
  if (!isBrowser()) {
    return {};
  }

  if (window.__TYK_CAMPAIGN_PARAMS__) {
    return { ...window.__TYK_CAMPAIGN_PARAMS__ };
  }

  const storage = getSessionStorage();
  if (!storage) {
    return {};
  }

  try {
    const raw = storage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") {
      window.__TYK_CAMPAIGN_PARAMS__ = parsed;
      return { ...parsed };
    }
  } catch (error) {
    return {};
  }

  return {};
};

const persistCampaignParams = (params) => {
  if (!isBrowser()) {
    return;
  }

  const sanitized = sanitizeParams(params);
  if (Object.keys(sanitized).length === 0) {
    return;
  }

  window.__TYK_CAMPAIGN_PARAMS__ = sanitized;

  const storage = getSessionStorage();
  if (!storage) {
    return;
  }

  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(sanitized));
  } catch (error) {
    // ignore storage errors (e.g., Safari private mode)
  }
};

export const captureCampaignParams = (search = "") => {
  if (!isBrowser()) {
    return {};
  }

  const incoming = extractCampaignParams(search || window.location.search || "");
  const existing = getStoredCampaignParams();

  if (Object.keys(incoming).length === 0) {
    if (Object.keys(existing).length === 0) {
      return {};
    }
    return existing;
  }

  const merged = { ...existing, ...incoming };
  persistCampaignParams(merged);
  return merged;
};
